
























import Vue from 'vue'
import Component from 'vue-class-component'
import moduleStore from '../index/store'
import { Toast  } from 'vant'
import Clipboard from 'clipboard'
import Cookies from 'js-cookie'

@Component({})
@moduleStore.initVuex({
	mutationNames: moduleStore.mutationNames,
	actionNames: moduleStore.actionNames
})
export default class ycdPaySuccess extends Vue {
  phone: string = ''
  title: string = ''
  rightsNum: number = 0
  // 是否为 IOS
  isIOS: boolean = false
  mounted() {
    // 判断当前是否为 iOS 环境
    this.isIOS = /(iPhone|iPad|iPod|iOS|mac os)/i.test(navigator.userAgent)
    // 读取传过来的手机号
    this.phone = this.$route.query.phone as string || ''
    // 读取传过来的套餐时间
    this.title = this.$route.query.title as string || ''
    const vipTime = (this.$route.query.vipTime as string) || "";
    const isOnlyVip = (this.$route.query.isOnlyVip as string) || "";
    this.rightsNum =
      +this.$route.query.rightsNum ||
      (parseInt(vipTime) >= 12 || isOnlyVip == "0" ? 10 : 9);

  }
  /**
   * 继续购买
   */
  buyAgain() {
    const channelCode = Cookies.get('CHANNEL_CODE') || ''
    this.$router.push({
      path: '/ycd-channel',
      query: {
        channelCode
      }
    })
  }
}

